import db from '../database'

// Function to retrieve data from PouchDB with a specific type
const exportPouchDBDataByType = async () => {
  try {
    // Fetch all documents
    const result = await db.allDocs({ include_docs: true });

    // Filter documents by the desired type
    const filteredDocs = result.rows
      .map((row) => row.doc)
      .filter((doc) => doc.type === "movie");  // Adjust this condition for your type property

    return filteredDocs;
  } catch (error) {
    console.error('Error retrieving documents:', error);
    throw error;
  }
};

// Function to export data as a JSON file
const exportToJsonFile = async () => {
  try {
    const data = await exportPouchDBDataByType();  // Fetch PouchDB data filtered by type
    const jsonString = JSON.stringify(data);           // Convert to JSON string
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    // Create a temporary link and trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = `exported_data_movies.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Remove link after download
  } catch (error) {
    console.error('Error exporting data:', error);
  }
};

export { exportToJsonFile }